import { render } from "./checkout.vue?vue&type=template&id=01bd8bf6&scoped=true"
import script from "./checkout.vue?vue&type=script&lang=js"
export * from "./checkout.vue?vue&type=script&lang=js"

import "./checkout.vue?vue&type=style&index=0&id=01bd8bf6&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bd8bf6"]])

export default __exports__